import EmptyState from "../common/EmptyState";

export default function AlertasPanel({ items = [] }) {
    return (
        <div>
            <h3>Alertas</h3>
            {!items.length ? (
                <EmptyState title="Sin alertas" message="No hay alertas activas por ahora." />
            ) : (
                <ul className="simple-list">
                    {items.map((item, i) => (
                        <li key={item.idAlerta || i}>
                            <strong>{item.titulo || item.tipoAlerta}</strong>
                            <p>{item.mensaje}</p>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}